module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"simulationData":"Datos de simulación","dataVerification":"Comprobación de datos","logs":"Logs","verify":"Comprobar","floidReport":"Reporte Floid","debtReport":"Reporte de deuda","otherReport":"SBIF - GESINTEL - Poder Judicial","notDefined":"No definido","reviewable":"Revisable","refused":"Rechazado por elegibilidad","approved":"Aprobado"}}')
  delete Component.options._Ctor
}
